"use client";

import { Container } from "@/components/Container";
import { AdaptiveText } from "@/components/Content/AdaptiveText";
import type { AdaptiveTextProps } from "@/components/Content/AdaptiveText";
import { Title } from "@/components/Content/Title";
import RadiantTitleCard from "@/components/RadiantTitleCard";
import type { RadiantTitleCardProps } from "@/components/RadiantTitleCard";
import { SlideUp } from "@/components/animations/page-transitions";
import { motion } from "framer-motion";

export type FeatureCard = RadiantTitleCardProps;

interface Props {
	features: FeatureCard[];
	title: string;
	text: AdaptiveTextProps["portableText"];
}

const ServicesFeatures = ({ features, title, text }: Props) => {
	return (
		<section className="relative py-24">
			<Container className="z-10">
				<SlideUp>
					<Title as="h2" className="text-center">
						{title}
					</Title>
				</SlideUp>

				<AdaptiveText
					portableText={text}
					className="mx-auto max-w-4xl text-center"
				/>

				<div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 pt-8 pb-16 md:grid-cols-2 lg:grid-cols-3">
					{features.map((feature, index) => (
						<motion.div
							key={index.toString()}
							initial={{ opacity: 0, y: 20 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.5, delay: index * 0.1 }}
							viewport={{ once: true }}
							className="h-full"
						>
							<RadiantTitleCard
								iconName={feature.iconName}
								title={feature.title}
								text={feature.text}
								className="h-full"
							/>
						</motion.div>
					))}
				</div>
			</Container>
		</section>
	);
};

export default ServicesFeatures;
